import React, { useCallback } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import {
  FlexMiddle as BaseFlexMiddle,
  SmallBody,
  TimeAgoRenderer,
  Card,
  Body,
  Tooltip
} from '@ubeya/shared-web/components';
import { media } from '@ubeya/shared-web/style';
import { ReactComponent as BaseDeleteIcon } from '@ubeya/shared-web/assets/delete.svg';

const DeleteIcon = styled(BaseDeleteIcon)`
  height: 15px;
  width: 15px;
  cursor: pointer;
  margin-left: 20px;

  > g {
    fill: ${({ theme }) => theme.colors.disabled};
  }
`;

const Container = styled(Card)`
  margin-bottom: 10px;
  border-radius: 5px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};
  padding: 5px;
  justify-content: space-between;
  ${media.mobile`10px 10px 10px 20px`} .name {
    max-width: 350px;
  }
`;

const TimeAgo = styled(SmallBody)`
  color: ${({ theme }) => theme.colors.disabled};
  font-size: 10px;
`;

const Content = styled(Body)`
  width: 100%;
  word-wrap: break-word;
  padding: 10px;
  font-size: 13px;
`;

const UserName = styled.div`
  font-size: 11px;
`;

const CommentDetails = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  width: 100px;
`;

const Details = styled.div`
  align-items: center;
  display: flex;
  margin-right: 10px;
`;

const FlexMiddle = styled(BaseFlexMiddle)`
  width: 80%;
`;

const Comment = ({
  id,
  comment,
  firstName,
  dateFormat,
  timeFormat,
  t,
  lastName,
  createdAt,
  deleteComment,
  showDelete = true
}) => {
  const onDeleteComment = useCallback(() => deleteComment({ id }), [deleteComment, id]);

  const date = moment.utc(createdAt).local().format(`${dateFormat} ${timeFormat}`);

  return (
    <Container className="employee-comments">
      <FlexMiddle>
        <Content>{comment}</Content>
      </FlexMiddle>

      <Details>
        <Tooltip body={date}>
          <CommentDetails>
            <UserName firstName={firstName} lastName={lastName}>
              {[firstName, lastName].filter((cur) => !!cur).join(' ')}
            </UserName>
            <TimeAgo>
              <TimeAgoRenderer rowData={{ createdAt }} dataKey="createdAt" disabledTooltip />
            </TimeAgo>
          </CommentDetails>
        </Tooltip>
        {showDelete && (
          <Tooltip body={t('delete')}>
            <DeleteIcon onClick={onDeleteComment} />
          </Tooltip>
        )}
      </Details>
    </Container>
  );
};

export default Comment;
